import ApiService from "./api.service";
import { server } from "./../core/data/config";
import { COMMS_HANDLER } from "./commsHandler";

export const initResponseService = {
    sendInitResponse
};

export const initBalanceService = {
    sendBalanceResponse
};

async function sendInitResponse(): Promise<any> {
    var d = new Date();
    var n = d.getTime();

    const gameInfo = (window as any).GAME_INFO;

    const data = {
        mode: "setup",
        gameID: gameInfo.gameID,
        accountID: gameInfo.accountID,
        stake: Number(gameInfo.stake),
        username: gameInfo.username,
        customerID: gameInfo.customerID,
        fun_real: gameInfo.playMode,
        ex_rate: gameInfo.ex_rate,
        currency: gameInfo.currency,
        site: gameInfo.site,
        jurisdiction: gameInfo.jurisdiction,
        now: n,
        gameType: gameInfo.gameType,
        version: gameInfo.version
    };

    const response = await COMMS_HANDLER.makeRequest({ data });

    return { data: response };
}

function sendBalanceResponse(): any {
    let url =
        "http://88.208.244.42/f1x2games/getAccountInfo.jsp?" +
        server.configGame.accountId +
        "&gameID=8308&siteID=1&installID=null&date=1640087505231";

    const api = new ApiService(url);
    const param = {
        gameRequest: { cmd: "init" }
    };
    if (server.configGame.method === "get") {
        return api.get(url, param);
    }
    if (server.configGame.method === "post") {
        return api.post(url, param);
    }
}
